<template>
  <div>
    <!-- Pay -->
    <a-modal v-model="visible" title="Payment Receipt" onOk="handleOk"
      :width="this.settings['isMobileView'] ? 360 : this.settings['isTabletView'] ? 560 : 720"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="print">Print</a-button>
      </template>
      <a-spin :spinning="spinning">
        <div v-if="student && studentFeeData">
          <pay-history :studentFeeData="studentFeeData" :student="student" :schoolData="schoolData" id="feePaymentMistory"/>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

import PayHistory from './partials/payhistory'

export default {
  name: 'StudentFeePayment',
  components: {
    PayHistory,
  },
  props: {
    isPublic: {
      default: false,
    },
    schoolData: {
      default: null,
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY',
      classFees: null,
      feesLoading: false,
      studentFeeId: null,
      studentFeeData: null,
      student: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openViewStudentFeeReceiptModal', this.showModal)
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    moment,
    showModal: function(studentFee, student) {
      this.studentFeeId = studentFee.id
      this.student = student
      console.log('student', student)
      const url = this.isPublic ? '/api/school/student_fee/' : '/api/student_fee/'
      this.spinning = true
      this.$http.get(url + studentFee.id, {
        params: {
          student_id: this.student.id,
        },
      })
        .then(({ data }) => {
          this.spinning = false
          this.studentFeeData = data.data
        })
        .catch(error => {
          this.spinning = false
          console.log(error)
        })

      // this.studentFeeData = studentFee
      this.visible = true
      // this.spinning = true
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    print () {
      // Pass the element id here
      this.$htmlToPaper('feePaymentMistory')
    },
  },
}
</script>
